<template>
  <div class="w-full md:w-1/2 lg:w-1/3">
    <div class="h-full bg-white shadow-[0_0_4px_rgba(51,51,51,0.2)]">
      <slot name="image" />
      <div class="p-4">
        <div class="relative mb-3 flex flex-wrap text-center">
          <div class="co-triangle-after-gray-6 w-1/2 bg-co-gray-200 p-3">
            <p class="mb-0 font-bold">
              <slot name="roleOne" />
            </p>
          </div>
          <div class="w-1/2 bg-co-success-500 p-3 text-white">
            <p class="mb-0 font-bold">
              <slot name="roleTwo" />
            </p>
          </div>
        </div>
        <p class="co-display-10 mb-2 font-bold text-co-gray-700">
          <slot name="catch" />
        </p>
        <h4 class="co-display-12 mb-3">
          <slot name="name" />
        </h4>
        <p class="mb-0">
          <slot name="comment" />
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.co-triangle-after-gray-6 {
  position: relative;
  &::before {
    position: absolute;
    top: 0;
    right: -0.5rem;
    bottom: 0;
    z-index: 1;
    width: 0.5rem;
    height: 1.25rem;
    margin: auto;
    content: '';
    border-top: 1rem solid transparent;
    border-bottom: 1rem solid transparent;
    border-left: 1rem solid #f1f1f1;
  }
}
</style>
